module.exports = __webpack_public_path__ + "eritrea.svg?3fd68dc7cde95f81a53ac4a6b32176d4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/eritrea.svg
// module id = 159
// module chunks = 10